import { useState } from 'react'
import { supabase } from '../lib/supabase'

export function AuthPage() {
  const [loading, setLoading] = useState(false)
  const [mode, setMode] = useState<'login' | 'register' | 'reset'>('login')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const loginWithGoogle = async () => {
    setLoading(true)
    if (new URLSearchParams(window.location.search).get('next') === 'premium') {
      localStorage.setItem('open_premium_after_login', '1')
    }
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin + '/' }
    })
    setLoading(false)
  }

  const handleEmailAuth = async () => {
    setError('')
    setMessage('')
    setLoading(true)
    if (mode === 'login') {
      const { error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) setError('Email o password errati')
    } else if (mode === 'register') {
      const { data, error } = await supabase.auth.signUp({ email, password })
      if (error) setError('Errore durante la registrazione: ' + error.message)
      else if (data.session) {
        window.location.href = '/'
      } else {
        setMessage('Account creato! Accedi ora.')
      }
    } else if (mode === 'reset') {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + '/reset-password'
      })
      if (error) setError('Errore durante il recupero password')
      else setMessage('Email di recupero inviata! Controlla la tua casella.')
    }
    setLoading(false)
  }

  const inputStyle = {
    width: '100%', border: '1px solid #E5E7EB', borderRadius: 12,
    padding: '12px 16px', fontSize: 15, color: '#111827',
    outline: 'none', boxSizing: 'border-box' as const, marginBottom: 12
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ backgroundColor: 'white', borderRadius: 24, padding: 40, maxWidth: 400, width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        
        {/* Logo */}
        <div style={{ width: 56, height: 56, margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="56" height="56" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="abg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#0a0a1a"/><stop offset="100%" stopColor="#0d1b3e"/></linearGradient>
              <linearGradient id="aacc" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor="#ff3a00"/><stop offset="100%" stopColor="#ff6b1a"/></linearGradient>
              <linearGradient id="ablu" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#1c3fff"/><stop offset="100%" stopColor="#5b7cff"/></linearGradient>
            </defs>
            <rect width="500" height="500" rx="70" fill="url(#abg)"/>
            <rect x="88" y="115" width="225" height="248" rx="22" fill="none" stroke="#ffffff" strokeWidth="1.5" opacity="0.12"/>
            <rect x="88" y="115" width="225" height="62" rx="22" fill="url(#ablu)"/>
            <rect x="88" y="145" width="225" height="32" fill="url(#ablu)"/>
            <circle cx="148" cy="117" r="14" fill="#0a0a1a" stroke="#5b7cff" strokeWidth="5"/>
            <circle cx="253" cy="117" r="14" fill="#0a0a1a" stroke="#5b7cff" strokeWidth="5"/>
            <rect x="142" y="90" width="12" height="27" rx="6" fill="#5b7cff"/>
            <rect x="247" y="90" width="12" height="27" rx="6" fill="#5b7cff"/>
            <rect x="112" y="202" width="149" height="11" rx="5.5" fill="url(#ablu)"/>
            <rect x="112" y="228" width="175" height="11" rx="5.5" fill="url(#aacc)"/>
            <circle cx="315" cy="318" r="52" fill="url(#aacc)"/>
            <polyline points="290,318 308,338 343,295" fill="none" stroke="white" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginBottom: 4 }}>Study Planner Schedule</h1>
        <p style={{ color: '#6B7280', marginBottom: 24, fontSize: 14 }}>
          {mode === 'login' ? 'Accedi al tuo account' : mode === 'register' ? 'Crea un account' : 'Recupera la password'}
        </p>

        {/* Google */}
        {mode !== 'reset' && (
          <>
            <button onClick={loginWithGoogle} disabled={loading} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '13px 0', borderRadius: 12, border: '1px solid #E5E7EB', backgroundColor: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 16 }}>
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              {loading ? 'Caricamento...' : 'Continua con Google'}
            </button>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <div style={{ flex: 1, height: 1, backgroundColor: '#E5E7EB' }} />
              <span style={{ fontSize: 12, color: '#9CA3AF' }}>oppure</span>
              <div style={{ flex: 1, height: 1, backgroundColor: '#E5E7EB' }} />
            </div>
          </>
        )}

        {/* Email */}
        <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} style={inputStyle} />
        {mode !== 'reset' && (
          <div style={{ position: 'relative' }}>
            <input type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} style={{...inputStyle, paddingRight: 44}} onKeyDown={e => e.key === 'Enter' && handleEmailAuth()} />
            <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#6B7280' }}>{showPassword ? '🙈' : '👁️'}</button>
          </div>
        )}

        {error && <p style={{ color: '#EF4444', fontSize: 13, marginBottom: 12 }}>{error}</p>}
        {message && <p style={{ color: '#10B981', fontSize: 13, marginBottom: 12 }}>{message}</p>}

        <button onClick={handleEmailAuth} disabled={loading} style={{ width: '100%', padding: '13px 0', borderRadius: 12, border: 'none', backgroundColor: '#1c3fff', color: 'white', fontSize: 15, fontWeight: 700, cursor: 'pointer', marginBottom: 16 }}>
          {loading ? 'Caricamento...' : mode === 'login' ? 'Accedi' : mode === 'register' ? 'Registrati' : 'Invia email di recupero'}
        </button>

        {/* Links */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {mode === 'login' && (
            <>
              <button onClick={() => { setMode('register'); setError(''); setMessage('') }} style={{ background: 'none', border: 'none', color: '#1c3fff', cursor: 'pointer', fontSize: 13 }}>Non hai un account? Registrati</button>
              <button onClick={() => { setMode('reset'); setError(''); setMessage('') }} style={{ background: 'none', border: 'none', color: '#9CA3AF', cursor: 'pointer', fontSize: 13 }}>Password dimenticata?</button>
            </>
          )}
          {mode === 'register' && (
            <button onClick={() => { setMode('login'); setError(''); setMessage('') }} style={{ background: 'none', border: 'none', color: '#1c3fff', cursor: 'pointer', fontSize: 13 }}>Hai già un account? Accedi</button>
          )}
          {mode === 'reset' && (
            <button onClick={() => { setMode('login'); setError(''); setMessage('') }} style={{ background: 'none', border: 'none', color: '#1c3fff', cursor: 'pointer', fontSize: 13 }}>Torna al login</button>
          )}
        </div>

        <p style={{ marginTop: 20, fontSize: 11, color: '#9CA3AF' }}>Accedendo accetti i nostri Termini di servizio e la Privacy Policy</p>
      </div>
    </div>
  )
}
